import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4bf588fc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4bf588fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf588fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bf588fc')) {
      api.createRecord('4bf588fc', component.options)
    } else {
      api.reload('4bf588fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4bf588fc&scoped=true", function () {
      api.rerender('4bf588fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/reservation/ToDoorService/index.vue"
export default component.exports